import { FiAlertCircle, FiCheckCircle } from 'react-icons/fi'
import { toast } from 'react-toastify'
import { Box, Flex, Link, Text, useColorModeValue } from '@chakra-ui/react'
import { TransactionStatus } from 'types'
import { formatBlockExplorerLink } from 'utils/web3'

export interface IToastOptions {
  title?: string
  isClosable?: boolean
  txStatus?: 'confirmed' | 'failed' | 'dropped'
  chainId: number
  duration?: number
  txHash: string
  onClose?: () => void
}

interface ITransactionToast {
  title: string
  chainId: number
  txHash: string
}

export const TransactionToast = ({
  title,
  chainId,
  txHash,
}: ITransactionToast) => {
  return (
    <Box
      as={Flex}
      flexDirection="column"
      gap={0}
      alignItems="flex-start"
      justifyContent="flex-start"
      pl={1}
    >
      <Text>{title}</Text>
      <Link
        href={formatBlockExplorerLink('tx', [chainId, txHash])}
        target={'_blank'}
        rel={'noreferrer'}
        _hover={{ textDecoration: 'none' }}
      >
        <Text color={'brand.500'} _hover={{ color: 'brand.400' }} fontSize="sm">
          View on Explorer
        </Text>
      </Link>
    </Box>
  )
}

const useTransactionToast = () => {
  const toastTheme = useColorModeValue('light', 'dark')

  const createTransactionToast = (options?: IToastOptions) => {
    if (!options) return
    const customToast = (
      <TransactionToast
        chainId={options.chainId}
        title={options.title as string}
        txHash={options.txHash}
      />
    )

    if (options.txStatus === TransactionStatus.confirmed) {
      toast.success(customToast, {
        autoClose: options.duration,
        theme: toastTheme,
        icon: <FiCheckCircle color="#07bc0c" size="xl" />,
      })
    } else {
      toast.error(customToast, {
        autoClose: options.duration,
        theme: toastTheme,
        icon: <FiAlertCircle color="#e74c3c" size="xl" />,
      })
    }
  }

  return createTransactionToast
}

export default useTransactionToast
